import { client } from '../client'

export const groqFetch = async () =>{
   return client.fetch(`*[_type in ["category" , "product", "drinksCategory", "drinksproduct", "info","highlights", "lunchMenu"]
    | order(importance asc)]{ 
        _type == "category"  =>{
          'type': 'category',
          title,
          title_eng,
          importance
        } ,     
        _type == "product" => {
        'type': 'product',
        title,
        title_eng,
        slug,
        publishedAt,
        price,
          weight,
          _rev,
          body,
          body_eng,
        categories->{name, title,title_eng, importance},
        mainImage{
              asset->{
                  _id,
                  url
              },
            alt
          }
        }, _type == "lunchMenu" => {
          'type': 'lunchMenuProduct',
          title,
          title_eng,
          slug,
          publishedAt,
          price,
            weight,
            _rev,
            body,
            body_eng,
          categories->{name, title,title_eng, importance},
          mainImage{
                asset->{
                    _id,
                    url
                },
              alt
            }
          },
        _type == "drinksCategory" =>{
          'type': 'drinksCategory',
          title,
          title_eng,
          importance
        },
        _type == "drinksproduct" =>{
          'type': 'drinksProduct',
          title,
          title_eng,
          slug,
          publishedAt,
          price,
            weight,
            _rev,
            body,
            body_eng,
          drinksCategory->{name, title,title_eng, importance},
          mainImage{
                asset->{
                    _id,
                    url
                },
              alt
            }
        },
        _type == "info" =>{
          "type" : 'info',
          variation,
          variation_eng,
          workingHours,
          restDay,
          restDay_eng,
          telephone,
          address,
          address_eng
        },
        _type == "highlights" =>{
            "type": 'highlights',
            highlight1,
            highlight1_eng,
            highlight2,
            highlight2_eng,
            highlight1_drinks,
            highlight1_drinks_eng,
            highlight2_drinks,
            highlight2_drinks_eng
        }
      }`)
}